import React, { useEffect, useState } from 'react';
import { collection, getDocs, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { useAuth } from '../context/authContext';
import { useFirebase } from '../context/firebaseContext';
import DynamicLayout from '../components/DynamicLayout';
import NoIndexHelmet from '../components/NoIndexHelmet';
import CalendarComponent from '../calendar/CalendarComponent';

const CalendarPage = () => {
  const { db } = useFirebase();
  const { user } = useAuth();
  const [journalMarks, setJournalMarks] = useState({});

  const fetchJournalEntries = async (dateKey) => {
    if (!user?.uid) return [];
    const entriesRef = collection(db, 'journal', user.uid, 'entries');
    const q = query(entriesRef, where('date', '==', dateKey));
    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  };

  useEffect(() => {
    if (!user?.uid) {
      setJournalMarks({});
      return undefined;
    }

    const entriesRef = collection(db, 'journal', user.uid, 'entries');
    const q = query(entriesRef, orderBy('date', 'desc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const marks = snapshot.docs.reduce((acc, doc) => {
        const entry = doc.data();
        if (!entry?.date) return acc;
        acc[entry.date] = (acc[entry.date] || 0) + 1;
        return acc;
      }, {});
      setJournalMarks(marks);
    });

    return unsubscribe;
  }, [db, user]);

  return (
    <DynamicLayout>
      <NoIndexHelmet title="Calendar | Saturnalia" />
      <CalendarComponent
        journalMarks={journalMarks}
        fetchJournalEntries={fetchJournalEntries}
      />
    </DynamicLayout>
  );
};

export default CalendarPage;
